import React from "react";
import { type IconType } from "react-icons";

interface IconBoxProps {
  icon: IconType;
  className?: string;
  iconClassName?: string;
}

export default function IconBox({
  icon: Icon,
  className = "",
  iconClassName = "",
}: IconBoxProps) {
  return (
    <div
      className={`bg-brand-dark-red relative flex h-[35px] w-[35px] items-center justify-center rounded-xl border border-white text-white md:h-[62px] md:w-[62px] ${className}`}
    >
      <Icon
        className={`h-[18px] w-[18px] md:h-[32px] md:w-[32px] ${iconClassName}`}
      />
    </div>
  );
}
